// Extracts a human-readable message from an axios error. Backend error bodies
// follow the shape { error, message } (e.g. the data-mapping 409 responses),
// so prefer `message`, then `error`, then a caller-supplied fallback.
export const getApiErrorMessage = (
  error,
  fallback = "Something went wrong."
) => {
  const data = error?.response?.data;
  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message) return data.message;
    if (typeof data.error === "string" && data.error) return data.error;
  }
  if (typeof data === "string" && data) return data;
  return fallback;
};
